import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axios";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export default function Courses() {
  const [category, setCatgory] = useState([]);

  const categories = [
    {
      id: 0,
      title: "Accounting & Financials",
      catNos: "12",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_acc_fin.png`,
    },
    {
      id: 1,
      title: "Business",
      catNos: "17",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_business.png`,
    },
    {
      id: 3,
      title: "Design",
      catNos: "22",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_design.png`,
    },
    {
      id: 4,
      title: "Personal Development",
      catNos: "15",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_per_dev.png`,
    },
    {
      id: 5,
      title: "Hospitality and Management",
      catNos: "8",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_hos_mgmt.png`,
    },
    {
      id: 6,
      title: "IT & software",
      catNos: "47",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_it_sw.png`,
    },
    {
      id: 7,
      title: "Personality Development and Careers",
      catNos: "12",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_per_dev.png`,
    },
    {
      id: 8,
      title: "Music",
      catNos: "5",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_music.png`,
    },
    {
      id: 9,
      title: "Teaching",
      catNos: "31",
      catImg: `${process.env.REACT_APP_SMIK_API_BASEURL}/UI/categories/cat_teaching.png`,
    },
  ];

  const { t } = useTranslation();

const fetchCategories = async () => {
  try {
    const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}categories`);
    //console.log("resssssssssssss", res.data.data);
  } catch (error) {
    console.error("Error fetching categories:", error);
  }
};


  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="cat-page">
      <div className="inner-wrapper">
        <div className="page-title">{t("All Categories")}</div>
      </div>

      <div className="inner-wrapper">
        {categories?.map((item) => {
          return (
            <div className="tile" key={item.id}>
              <div className="underlay">
                <img src={item.catImg} alt="Categories"  loading="lazy" />
              </div>

              <div className="cat_info">
                <div className="tile-title">{item.title}</div>
                {/* <div className="no-of-cats">{item.catNos}</div> */}
                <div className="all-courses-links">
                  <a href="#">
                    {t("Checkout all")} {item.catNos} {t("courses")}
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
